export default "__VITE_ASSET__D2LK56FS__"